import "./App.css";
import "./Styles/fontfamily.css";

import NavbarComp from "./Component/NavbarComp";
import { FooterComp } from "./Component/FooterComp";

import MainRoutes from "./Pages/MainRoutes";
import GdprModal from "./Pages/GDPRModal";
import { HelmetProvider } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
function App() {
    const helmetContext = {};

  const [showFooter, setShowFooter] = useState(false);
  const location = useLocation();
  const hideNavAndFooter = location.pathname === '/subscribe';
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFooter(true);
    }, 2000); // 2 seconds
    return () => clearTimeout(timer); // cleanup on unmount
  }, []);
  return (
    <>
      {/* <NavbarComp />
      <GdprModal />
      <MainRoutes />
      <FooterComp /> */}

          <div>
        <HelmetProvider context={helmetContext}>
          {/* <Navbar /> */}
          {!hideNavAndFooter && <NavbarComp />}

          <MainRoutes />
          {/* {showFooter && <Footer />} */}
          {!hideNavAndFooter && showFooter && <FooterComp />}
        </HelmetProvider>
      </div>
    </>
  );
}

export default App;
